import { useSplitEnabled } from '@buffer-mono/features'

/**
 * Gates the menu items that hand out a Buffer link to a post or a channel-less
 * draft. Resolution is never gated: a link only some readers can open is not
 * shareable. A progressive rollout, not an experiment, hence no `geid-` prefix.
 */
export const POST_PERMALINKS_FLAG = 'publish-post-permalinks'

export function usePostPermalinksEnabled(): boolean {
  const { isEnabled, isReady } = useSplitEnabled(POST_PERMALINKS_FLAG)

  return isReady && isEnabled
}
